import React from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollReveal from '../../utils/useScrollReveal';
import maillot1 from '../../assets/maillots/maillot1.png';
import maillot2 from '../../assets/maillots/maillot2.png';
import maillot3 from '../../assets/maillots/maillot3.png';

export default function CtaBoutique() {
  const navigate = useNavigate();
  const ctaRef = useScrollReveal();

  return (
    <section className="container mx-auto px-4 my-16">
      <div
        ref={ctaRef}
        className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center justify-between gap-8 relative overflow-hidden shadow-2xl opacity-0 translate-y-8 transition-all duration-700 ease-out will-change-transform"
      >
        {/* Left: Images */}
        <div className="flex-shrink-0 relative w-[280px] h-[160px] md:w-[320px] md:h-[180px] flex items-center justify-center mb-6 lg:mb-0">
          {/* Maillot gauche */}
          <img
            src={maillot1}
            alt="Maillot 1"
            className="absolute left-0 top-1/2 -translate-y-1/2 w-28 md:w-32 z-10 transform -rotate-6 hover:scale-110 transition-transform duration-300 drop-shadow-lg"
          />
          {/* Maillot centre */}
          <img
            src={maillot2}
            alt="Maillot 2"
            className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 w-32 md:w-36 z-20 hover:scale-110 transition-transform duration-300 drop-shadow-2xl"
          />
          {/* Maillot droite */}
          <img
            src={maillot3}
            alt="Maillot 3"
            className="absolute right-0 top-1/2 -translate-y-1/2 w-28 md:w-32 z-10 transform rotate-6 hover:scale-110 transition-transform duration-300 drop-shadow-lg"
          />
        </div>

        {/* Center: Text */}
        <div className="flex-1 text-center z-10 px-4">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-title font-bold text-efafcYellow mb-4 uppercase tracking-wider drop-shadow-lg">
            VISITE LA BOUTIQUE !
          </h2>
          <p className="text-white text-base md:text-lg font-medium max-w-xl mx-auto opacity-90 leading-relaxed">
            Découvre notre sélection : maillots, packs entraînement, vestes, doudounes et bien plus encore !
          </p>
        </div>

        {/* Right: Button */}
        <div className="flex-shrink-0 z-10 mt-6 lg:mt-0">
          <button
            onClick={() => navigate('/boutique')}
            className="bg-[#BDFF00] hover:bg-[#a8e600] text-efafcDark font-bold text-lg py-4 px-8 rounded-xl shadow-lg transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-efafcYellow focus:ring-offset-2 focus:ring-offset-efafcDark"
          >
            Aller à la boutique
          </button>
        </div>
      </div>
    </section>
  );
}
